export default "__VITE_ASSET__CF0PZOur__"